<script setup lang="ts"></script>
<template>
  <section id="about-project" class="features-section">
    <h2 class="features-title">Что даёт Брокер Пасс</h2>
    <div class="features-list">
      <div class="feature-card">
        <img class="feature-icon" src="./images/right-arrow.svg" alt="Arrow" />
        <div class="feature-content">
          <h3 class="feature-title">Доступ к событиям CRE.ru</h3>
          <p class="feature-text">
            Участие в конференциях, форумах и встречах рынка без стартовых
            затрат
          </p>
        </div>
      </div>
      <div class="feature-card">
        <img class="feature-icon" src="./images/right-arrow.svg" alt="Arrow" />
        <div class="feature-content">
          <h3 class="feature-title">Сообщество профессионалов</h3>
          <p class="feature-text">
            Участие в закрытых встречах и специальных акциях для консультантов и
            брокеров
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
@use './styles/styles.scss' as *;
.features-section {
  position: relative;
  height: 822px;
  background: url('./images/features-back.png') no-repeat left center / auto
    100%;

  @media (max-width: $tablet-view) {
    height: 631px;
  }

  @media (max-width: $mobile-view) {
    background: url('./images/features-mobile-back.png') no-repeat center
      center / auto 100%;
    height: 554px;
  }

  .features-title {
    color: var(--dark-charcoal, #313030);
    @include font-regular;
    font-size: 64px;
    line-height: 100%;
    margin: 99px 0 0 129px;
    width: 420px;

    @media (max-width: $tablet-view) {
      font-size: 46px;
      margin: 136px 0 0 30px;
      width: fit-content;
      max-width: 100%;
    }

    @media (max-width: $mobile-view) {
      font-size: 32px;
      margin: 40px 0 0 20px;
    }
  }

  .features-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 618px;
    margin: 129px 0 0 90px;

    @media (max-width: $tablet-view) {
      margin: 30px 0 0 30px;
    }

    @media (max-width: $mobile-view) {
      margin: 30px 0 0 0;
      width: 100%;
    }

    .feature-card {
      background: #ffffff;
      padding: 30px;
      display: flex;
      flex-direction: row;
      gap: 30px;
      width: 618px;

      @media (max-width: $tablet-view) {
        width: 573px;
      }

      @media (max-width: $mobile-view) {
        width: 100%;
        padding: 20px;
        gap: 20px;
      }

      .feature-icon {
        width: 51px;
        height: 48px;

        @media (max-width: $mobile-view) {
          width: 40px;
          height: 38px;
        }
      }

      .feature-content {
        display: flex;
        flex-direction: column;
        gap: 10px;

        .feature-title {
          color: var(--chiness-black, #111111);
          @include font-regular;
          font-size: 32px;
          line-height: 130%;
          margin: 0;

          @media (max-width: $tablet-view) {
            font-size: 24px;
          }

          @media (max-width: $mobile-view) {
            font-size: 18px;
          }
        }

        .feature-text {
          color: var(--dark-charcoal, #313030);
          @include font-regular;
          font-size: 22px;
          line-height: 130%; // Было 100%, но в BrokerAudience 130%. Проверю.
          margin: 0;

          @media (max-width: $tablet-view) {
            font-size: 18px;
          }

          @media (max-width: $mobile-view) {
            font-size: 14px;
          }
        }
      }
    }
  }
}
</style>
